import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaBars, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";
import { IoNotifications, IoPersonCircleSharp, IoLogoWhatsapp, IoSearch } from "react-icons/io5";
import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import { Link } from "react-router-dom";
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { FaMapMarkedAlt, FaWhatsapp, FaPhoneAlt, FaArrowLeft } from "react-icons/fa";
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';

function Index() {
  const [categorydata, setcategorydata] = useState([]);
  const { user, fulluser } = useContext(AuthContext);
  const [Userecommrce, setUserecommrce] = useState([]);
  const [invesment, setinvesment] = useState([]);
  const [UserActivity, setUserActivity] = useState(null);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);



  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };


  const customer_ecommorce = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_ecommorce", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserecommrce(res.data);
          } else {
          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };


  const myinvesmentlist = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/myinvesmentlist", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          console.log(res.data);
          if (res.data.status == 'success') {
            setinvesment(res.data);
          } else {
          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };
  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_details", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserActivity(res.data);
          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };

  const getWithdrawalHistory = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      try {
        const res = await axios.get(site_url + "/withdrawal-history", {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        });
        if (res.data.status === 'success') {
          setWithdrawalHistory(res.data.data || []);
        }
      } catch (err) {
        console.error("Withdrawal History Error:", err.response?.data);
      }
    }
  };

  useEffect(() => {
    myinvesmentlist();
    customer_ecommorce();
    getUserdetails();
    if (user) {
      getWithdrawalHistory();
    }
  }, [user]);




  return (
    <div>
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> My Purchases And Rewards</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>
      <Container className="mt-1" style={{ marginBottom: '20%' }}>
        {/* Summary Table Section */}
        <div className="col-12 mt-3 mb-4">
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '15px',
            borderRadius: '12px 12px 0 0',
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '18px'
          }}>
            Shop & Saved
          </div>

          <div style={{ overflowX: 'auto', background: '#fff', border: '1px solid #dee2e6', borderRadius: '0 0 12px 12px' }}>
            <table className="table table-bordered mb-0" style={{ marginBottom: 0, fontSize: '14px' }}>
              <thead style={{ background: '#f8f9fa' }}>
                <tr>
                  <th style={{ width: '8%', textAlign: 'center', padding: '12px 8px', fontWeight: 'bold', border: '1px solid #dee2e6' }}>SL.NO.</th>
                  <th style={{ width: '45%', padding: '12px', fontWeight: 'bold', border: '1px solid #dee2e6' }}>Description</th>
                  <th style={{ width: '22%', textAlign: 'center', padding: '12px', fontWeight: 'bold', border: '1px solid #dee2e6' }}>value-</th>
                  <th style={{ width: '25%', textAlign: 'center', padding: '12px', fontWeight: 'bold', border: '1px solid #dee2e6' }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {/* Row 1: Total Saved */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>1</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total Saved</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(Userecommrce?.billorders || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 2: Total reward points earned */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>2</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total reward points earned</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.lifetime_total).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 3: Total reward points available for redemption */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>3</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total reward points available for redemption</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.redemption_total || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d', fontSize: '10px' }}>
                    (Redeem: ₹{parseFloat(UserActivity?.data?.redemption_total || 0).toFixed(2)} )
                  </td>
                </tr>

                {/* Row 4: Total Instant Reward points earned */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>4</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total Instant Reward points earned</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.instant_bonus || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 5: Total "APM monthly Bonus" Received */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>5</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total "APM monthly Bonus" Reward Points</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.apm_bonus || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 6: Total referral Bonus earned */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>6</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total referral Bonus earned</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.ref_bonus || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 7: Total e-gift voucher earned */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>7</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total e-gift voucher earned</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.free_gift_bonus || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 8: Total Reward Points Used */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>8</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total Reward Points Used</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.total_points_used || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 9: Total Reward Points Expired */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>9</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total Reward Points Expired</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.total_points_expired || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 10: Total Recharge done */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>10</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total Recharge done</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {parseFloat(UserActivity?.data?.total_rechange || 0).toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 11: Total Credit card Payments */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>11</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total Credit card Payments</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {(() => {
                      // Calculate from billorders where paytype is 'online'
                      // This would need to be fetched from API or calculated
                      return '0.00';
                    })()}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>

                {/* Row 12: Total point to account transfer */}
                <tr>
                  <td style={{ textAlign: 'center', padding: '12px 8px', border: '1px solid #dee2e6' }}>12</td>
                  <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Total point to Bank transfer</td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', fontWeight: '600' }}>
                    🪙 {(() => {
                      const totalTransferred = withdrawalHistory
                        .filter(w => w.status === 'approved' || w.status === 'processing' || w.status === 'completed')
                        .reduce((sum, w) => sum + parseFloat(w.amount || 0), 0);
                      return totalTransferred.toFixed(2);
                    })()}
                  </td>
                  <td style={{ textAlign: 'center', padding: '12px', border: '1px solid #dee2e6', color: '#6c757d' }}>-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Modern Card for Suspended Reward Points */}
        <div className="col-12 mt-4">
          <div className="stat-box" style={{
            background: 'linear-gradient(135deg, #FF512F 0%, #DD2476 100%)',
            borderRadius: '16px',
            padding: '25px',
            color: 'white',
            boxShadow: '0 10px 20px rgba(221, 36, 118, 0.3)',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <h4 style={{ color: 'white', marginBottom: '10px', fontWeight: '600', textTransform: 'uppercase', fontSize: '14px', letterSpacing: '1px' }}>
                Suspended Reward Points
              </h4>
              <h1 style={{ color: 'white', fontSize: '42px', fontWeight: '800', margin: '10px 0' }}>
                🪙 {parseFloat(UserActivity?.data?.suspended_bonus || 0).toFixed(2)}
              </h1>
              <p style={{ margin: 0, fontSize: '13px', opacity: 0.9 }}>
              </p>
            </div>
            {/* Background Icon Decoration */}
            <div style={{
              position: 'absolute',
              right: '-20px',
              bottom: '-20px',
              opacity: 0.2,
              transform: 'rotate(-20deg)'
            }}>
              <ion-icon name="alert-circle-outline" style={{ fontSize: '120px', color: 'white' }}></ion-icon>
            </div>
          </div>
        </div>

        <div className="col-12" style={{ display: 'none' }}>
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box insta align-items-center justify-center">
              <div className='row'>
                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>My Investment Rewards points </h4></div>
                  <h2 className='text-white text-center'>🪙 {Userecommrce?.billorders}</h2>
                </div>
                <div class="col-4">
                  <img style={{ width: '100px', position: 'absolute', marginTop: '-10%' }} src='./thropy.png' />
                </div>
              </div>

            </div>
          </Link>

          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box sundaybonues align-items-center justify-center">
              <div className='row'>

                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./wallet.png' />
                </div>

                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>My Rewards points</h4></div>
                  <h2 className='text-white text-center'>🪙 {Userecommrce?.instant_bonus}</h2>
                </div>


              </div>

            </div>
          </Link>
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box refbonues align-items-center justify-center">
              <div className='row'>



                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>Rewards points Available</h4></div>
                  <h2 className='text-white text-center'>🪙 {(UserActivity?.data?.cash_available ?? 0)}</h2>
                </div>
                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./thropy.png' />
                </div>

              </div>

            </div>
          </Link>
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box suspended_bonus align-items-center justify-center">
              <div className='row'>

                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./wallet.png' />
                </div>

                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>Expired Rewards points </h4></div>
                  <h2 className='text-white text-center'>🪙 {UserActivity?.data?.expried_cash}</h2>
                </div>


              </div>

            </div>
          </Link>
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box billamountbonues align-items-center justify-center">
              <div className='row'>



                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>Instant Rewards points</h4></div>
                  <h2 className='text-white text-center'>🪙 {UserActivity?.data?.instant_bonus}</h2>
                </div>
                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./thropy.png' />
                </div>

              </div>

            </div>
          </Link>
          {(UserActivity?.data?.sunday_bonus_enabled !== 0) && (
            <Link to={``} >
              <div style={{ height: '106px', marginTop: '15%' }} className="stat-box sundaybonues align-items-center justify-center">
                <div className='row'>

                  <div class="col-4">
                    <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./wallet.png' />
                  </div>

                  <div class="col-8">
                    <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>Sunday Rewards points</h4></div>
                    <h2 className='text-white text-center'>🪙 {UserActivity?.data?.sunday_bonus}</h2>
                  </div>


                </div>

              </div>
            </Link>
          )}
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box insta align-items-center justify-center">
              <div className='row'>



                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>Rewards Voucher Received</h4></div>
                  <h2 className='text-white text-center'>🪙 {UserActivity?.data?.mile_bonus}</h2>
                </div>
                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./thropy.png' />
                </div>

              </div>

            </div>
          </Link>
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box refbonues align-items-center justify-center">
              <div className='row'>

                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./wallet.png' />
                </div>

                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>APM Rewards points</h4></div>
                  <h2 className='text-white text-center'>🪙 {UserActivity?.data?.apm_bonus}</h2>
                </div>


              </div>

            </div>
          </Link>
          <Link to={``} >
            <div style={{ height: '106px', marginTop: '15%' }} className="stat-box billamountbonues align-items-center justify-center">
              <div className='row'>



                <div class="col-8">
                  <div style={{ marginTop: '4%' }} className="bonuestitle text-center"><h4>Referral welcome Rewards points</h4></div>
                  <h2 className='text-white text-center'>🪙 {UserActivity?.data?.ref_wel}</h2>
                </div>
                <div class="col-4">
                  <img style={{ width: '90px', position: 'absolute', marginTop: '-10%', marginLeft: '3%' }} src='./thropy.png' />
                </div>

              </div>

            </div>
          </Link>
        </div>
      </Container>
      <Footer />

    </div>
  )
}

export default Index